// src/api/cart.ts
import { postRequest } from "./postRequest";

export type ApiResponse<T> = {
  success: boolean;
  errorCode?: string | null;
  errorDetail?: string | null;
  data?: T;
};

// ---- Identify
export type Identify = {
  sepetId?: number;
  musteriId?: number;
  ziyaretciAnahtari?: string;
};

// ---- Header / Items / Totals
export type CartHeader = {
  sepetId: number;
  musteriId?: number | null;
  ziyaretciAnahtari?: string | null;
  paraBirimiKodu: string;
  indirimKodu?: string | null;
  notlar?: string | null;
  aktifMi: boolean;
  silindiMi: boolean;
  olusturmaTarihi: string;
  guncellemeTarihi?: string | null;
};

export type CartItem = {
  sepetKalemId: number;
  urunId: number;
  varyantId: number;
  urunAdi?: string | null;
  secenekOzeti?: string | null;
  adet: number;
  birimFiyatNet: number;
  vergiOraniYuzde: number;
  satirIndirimNet: number;
  olusturmaTarihi: string;
  guncellemeTarihi?: string | null;
};

export type CartTotals = {
  toplamNet: number;
  toplamVergi: number;
  toplamBrut: number;
};

export type CartSummary = {
  header: CartHeader;
  totals: CartTotals;
  items: CartItem[];
};

// ---- Upsert payload
export type UpsertItemPayload = {
  urunId: number;
  varyantId: number;
  urunAdi?: string | null;
  secenekOzeti?: string | null;
  adet: number;
  birimFiyatNet: number;
  vergiOraniYuzde: number;
  satirIndirimNet?: number | null;
};

export const cartApi = {
  // Aktif sepet getir/oluştur
  ensureActive: (p: {
    musteriId?: number;
    ziyaretciAnahtari?: string;
    paraBirimiKodu?: string; // default TRY
  }) =>
    postRequest<typeof p, ApiResponse<CartHeader>>("/Sepetler/aktif-getir-olustur", p),

  // Özet
  summary: (p: Identify) =>
    postRequest<Identify, ApiResponse<CartSummary>>("/Sepetler/ozet", p),

  // Satır ekle/güncelle
  upsertItem: (p: Identify & UpsertItemPayload) =>
    postRequest<typeof p, ApiResponse<string>>("/Sepetler/satir-ekle-guncelle", p),

  // Adet değiştir
  changeQty: (p: Identify & { sepetKalemId: number; adet: number }) =>
    postRequest<typeof p, ApiResponse<string>>("/Sepetler/satir-adet", p),

  // Satır sil
  deleteItem: (p: Identify & { sepetKalemId: number }) =>
    postRequest<typeof p, ApiResponse<string>>("/Sepetler/satir-sil", p),

  // Kupon
  setCoupon: (p: Identify & { indirimKodu?: string | null }) =>
    postRequest<typeof p, ApiResponse<string>>("/Sepetler/kupon", p),

  // Para birimi
  setCurrency: (p: Identify & { paraBirimiKodu: string }) =>
    postRequest<typeof p, ApiResponse<string>>("/Sepetler/parabirimi", p),

  // Not
  setNote: (p: Identify & { notlar?: string | null }) =>
    postRequest<typeof p, ApiResponse<string>>("/Sepetler/not", p),

  // Temizle
  clear: (p: Identify) =>
    postRequest<Identify, ApiResponse<string>>("/Sepetler/temizle", p),

  // ✅ CHECKOUT (AktifMi=0 yapar)
  checkout: (p: Identify) =>
    postRequest<Identify, ApiResponse<string>>("/Sepetler/checkout", p),

  // Misafir -> Üye taşı
  attachGuestToMember: (p: { musteriId: number; ziyaretciAnahtari: string }) =>
    postRequest<typeof p, ApiResponse<string>>("/Sepetler/misafirden-uyeye", p),
};
